<template>
    <div class="desktop-filters">
        <FilterInputs class="desktop-filters__selects" />
    </div>
</template>

<script>
    import FilterInputs from 'components/user/organizationreport/filters/FilterInputs'
    import DesktopClearFilters from 'components/user/organizationreport/filters/DesktopClearFilters'

    export default {
        name: 'DesktopFilters',
        components: {
            FilterInputs,
            DesktopClearFilters
        }
    }
</script>

<style scoped lang="scss">
    .desktop-filters {
        &__selects {
            display: flex;
            flex: 1;
            flex-wrap: wrap;
        }
    }
</style>
